import React from 'react';
import styled from 'styled-components';
import Skeleton from '@material-ui/lab/Skeleton';

const RootWrapper = styled.div`
    & + & {
        margin-top: 25px;
    }
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    ${p => p.theme.muiTheme.breakpoints.up('lg')} {
        margin-bottom: 15px;
    }
`;

const EarningStatisticSkeleton: React.FC = ({children}) => {
    return (
        <RootWrapper>
            <Header>
                <Skeleton width={250} height={40} />
                <Skeleton variant="circle" width={30} height={30} />
            </Header>
            {children}
        </RootWrapper>
    );
};

export default EarningStatisticSkeleton;
